import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { PageHeroComponent } from '../shared/page-layout/page-hero.component';
import { WAREHOUSING_NAV_ITEMS, WarehousingSection } from './warehousing-common';
import { LocaleService } from '../i18n/locale.service';

@Component({
  selector: 'app-warehousing-page-header',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, MenuModule, PageHeroComponent],
  template: `
    <app-page-hero eyebrow="Warehousing" [title]="title" [subtitle]="subtitle">
      <div actions class="warehousing-header-actions">
        <p-button [label]="t('navigation.warehouse_menu', 'Warehouse Menu')" icon="pi pi-bars" severity="secondary" [outlined]="true"
          (onClick)="sectionMenu.toggle($event)"></p-button>
        <p-menu #sectionMenu [model]="navMenuItems" [popup]="true" appendTo="body"></p-menu>
        <ng-content select="[actions]"></ng-content>
      </div>
    </app-page-hero>
  `,
  styles: [`
    :host {
      display: block;
      margin-bottom: 1rem;
    }
  `]
})
export class WarehousingPageHeaderComponent {
  private readonly localeService = inject(LocaleService);

  @Input() title = 'Warehousing Control Center';
  @Input() subtitle = 'Item master, stock entry, dispatch, refurbishment, and storage billing.';
  @Input() activeSection: WarehousingSection = 'overview';

  t(key: string, fallback: string): string {
    return this.localeService?.translateIfPresent(key, fallback) ?? fallback;
  }

  get navMenuItems(): MenuItem[] {
    return WAREHOUSING_NAV_ITEMS.map(item => {
      const navKey = item.label
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_|_$/g, '');
      const translated = this.localeService?.translateIfPresent(`navigation.${navKey}`, item.label) ?? item.label;
      return {
        label: translated,
        icon: item.icon,
        routerLink: item.route
      };
    });
  }
}
